import { render, staticRenderFns } from "./VisualizacaoBase.vue?vue&type=template&id=19b0e702&"
import script from "./VisualizacaoBase.vue?vue&type=script&lang=js&"
export * from "./VisualizacaoBase.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacaoBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports